export const defaultConsentPhrasesIds = { consentContact: 1, consentPartners: 2 }

//nouvelle version iso avec ce qui est attendu par le code
export const defaultConsentPhrases = {
  "1": {
    id: 1,
    key: "consentContact",
    phrase: "J'accepte que L'École Française utilise les données renseignées dans ce formulaire pour me contacter et suivre mon dossier"
  },
  "2": {
    id: 2,
    key: "consentPartners",
    phrase: "J'accepte de recevoir par email des offres commerciales et informations de la part de L'École Française"
  }
};
